export const warehouseDispatchRoutes = {
  warehouseDispatch: {
    path: "/warehouse-dispatch",
    name: "warehouseDispatch",
  },
  warehouseDispatchRule: {
    path: "/warehouse-dispatch-rule/:id?",
    name: "warehouseDispatchRule",
  },
  newWarehouseDispatchRule: {
    path: "/warehouse-dispatch-rule/new",
    name: "newWarehouseDispatchRule",
  },
};
